<template>
  <el-dropdown @command="handleLangChange" trigger="click">
    <span class="el-dropdown-link" style="color:rgba(255,255,255,0.85);cursor:pointer;">
      {{ currentLangLabel }}
      <i class="el-icon-arrow-down el-icon--right" style="color:rgba(255,255,255,0.85)"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh-CN">{{ $t('simplified chinese') }}</el-dropdown-item>
      <el-dropdown-item command="zh-HK">{{ $t('traditional chinese') }}</el-dropdown-item>
      <el-dropdown-item command="en-HK">{{ $t('english') }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { getLanguage, setLanguage, LANG_ZH_CN, LANG_ZH_HK, LANG_EN_HK } from '@/utils/storage'

export default {
  name: 'LanguageSwitcher',
  computed: {
    currentLangLabel() {
      const lang = getLanguage()
      if (lang === LANG_ZH_HK) return this.$t('traditional chinese')
      if (lang === LANG_EN_HK) return this.$t('english')
      return this.$t('simplified chinese')
    }
  },
  methods: {
    handleLangChange(lang) {
      this.$setLang(lang)
    }
  }
}
</script>
